import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'hm-hebrew-pager',
  templateUrl: './hebrew-pager.component.html',
  styleUrls: ['./hebrew-pager.component.scss']
})
export class HebrewPagerComponent implements OnInit {

  @Input() activeLetter;
  @Output() letterClick = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onLetterClick(letterNum:number): void {
    this.letterClick.emit(letterNum);
  }

}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/hebrew-pager/hebrew-pager.component.ts